import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import ErrorBoundary from "@/components/ErrorBoundary";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Quote from "@/pages/Quote";
import Admin from "@/pages/Admin";
import Gallery from "@/pages/Gallery";
import ServiceTown from "@/pages/ServiceTown";
import MobileCallBar from "@/components/MobileCallBar";

const ScrollToTop = ({ lenisRef }) => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (lenisRef.current) {
            lenisRef.current.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, lenisRef]);
    return null;
};

function App() {
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        lenisRef.current = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            lenisRef.current = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <HelmetProvider>
            <BrowserRouter>
                <ScrollToTop lenisRef={lenisRef} />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/pricing" element={<Pricing />} />
                    <Route path="/quote" element={<Quote />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/stump-grinding/:slug" element={<ServiceTown />} />
                    <Route path="*" element={<Home />} />
                </Routes>
                <Footer />
                <MobileCallBar />
            </BrowserRouter>
            </HelmetProvider>
            <div className="grain-overlay" aria-hidden="true" />
        </ErrorBoundary>
    );
}

export default App;
